import { Card, CardMedia, Grid, Stack } from "@mui/material";

import impactBaselineCurrent from "../../resources/images/ImpactBaselineCurrent.png";
import impactEnvironment from "../../resources/images/ImpactEnvironment.png";
import impactInterventions from "../../resources/images/ImpactInterventions.png";
import impactTotalSavings from "../../resources/images/ImpactTotalSavings.png";
import impactSavingsByCategory from "../../resources/images/ImpactSavingsByCategory.png";

const Impact = () => {
  return (
    <Grid container spacing={3} justifyContent="center" alignItems="center">
      <Grid item xl={3} lg={12} md={12} sm={12} xs={12}>
        <Stack display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Card sx={{ paddingX: 4, paddingY: 6, borderRadius: 4 }}>
            <CardMedia
              component="img"
              src={impactInterventions}
              alt="Impact Interventions"
              style={{ objectFit: "contain" }}
            />
          </Card>
        </Stack>
      </Grid>
      <Grid item xl={3} lg={12} md={12} sm={12} xs={12}>
        <Stack spacing={3} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Card sx={{ padding: 4, borderRadius: 4 }}>
            <CardMedia
              component="img"
              src={impactSavingsByCategory}
              alt="Impact Savings by Category"
              style={{ objectFit: "contain" }}
            />
          </Card>
          <Card sx={{ padding: 4, borderRadius: 4 }}>
            <CardMedia
              component="img"
              src={impactBaselineCurrent}
              alt="Impact Baseline vs Current"
              style={{ objectFit: "contain" }}
            />
          </Card>
        </Stack>
      </Grid>
      <Grid item xl={3} lg={12} md={12} sm={12} xs={12}>
        <Stack spacing={3} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Card sx={{ padding: 4, borderRadius: 4 }}>
            <CardMedia
              component="img"
              src={impactTotalSavings}
              alt="Impact Total Savings"
              style={{ objectFit: "contain" }}
            />
          </Card>
          <Card sx={{ padding: 4, borderRadius: 4 }}>
            <CardMedia
              component="img"
              src={impactEnvironment}
              alt="Impact Environment"
              style={{ objectFit: "contain" }}
            />
          </Card>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Impact;
